function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.25,4v1.5H7.75V4ZM7.75,28.05h16.5v-1.5H7.75ZM15.4,17.7v4.09l-2.12-2.12-1.06,1.06,3.4,3.4a.75.75,0,0,0,1.06,0l3.4-3.4L19,19.67,16.9,21.79V10.21L19,12.33l1.06-1.06-3.4-3.4a.75.75,0,0,0-1.06,0l-3.4,3.4,1.06,1.06,2.12-2.12V17.7Z",
  fill: "#33ba69"
});

var SvgDistanceVerticalIcon = function SvgDistanceVerticalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDistanceVerticalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/distance_vertical_icon.1cfa3189.svg";
export { ForwardRef as ReactComponent };